import { isUndefinedOrNull } from "./assertions";
import { supportedColors } from "./theme";
import { ResponsiveProp, Breakpoints } from "./types";

export function getInitials(name: string, length = 1) {
  if (!name || length < 1) return "";
  if (length == 1) return name.charAt(0);
  return name
    .trim()
    .split(/\s+/)
    .slice(0, length)
    .map((c) => c.charAt(0))
    .join("");
}

export function warnDeprecation(
  deprecatedProp: any,
  newProp: any,
  value?: string
) {
  if (!isUndefinedOrNull(value)) {
    console.warn(
      `${deprecatedProp} is deprecated and will be removed in a future release. ${newProp ? `Please use ${newProp} instead.` : ""}`
    );
  }
}

export function hashCode(text: string) {
  const str = String(text);
  let hash = 0;
  let char;
  if (str.trim().length === 0) return hash;
  for (let i = 0; i < str.length; i++) {
    char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    // Convert to 32bit integer
    hash &= hash;
  }

  return Math.abs(hash);
}

export function id() {
  return Math.random().toString(36);
}

export function getRandomColor(string: string) {
  const hash = hashCode(string);
  return supportedColors[hash % supportedColors.length];
}

export function breakpointClassNames<T>(
  prefix: string,
  value: ResponsiveProp<T>
): string {
  if (!value) return "";

  if (typeof value === "string" || typeof value === "number") {
    return `${prefix}-${value}`;
  }

  let classNames = "";

  for (const key of Object.keys(value as Record<Breakpoints, T>)) {
    const breakpoint = key as Breakpoints;
    const breakpointValue = (value as Record<Breakpoints, T>)[breakpoint];

    if (breakpointValue) {
      classNames && (classNames += " ");
      classNames +=
        breakpoint === "base"
          ? `${prefix}-${breakpointValue}`
          : `${breakpoint}:${prefix}-${breakpointValue}`;
    }
  }

  return classNames;
}
